<template>
  <main class="home">
    <section class="banner position-r" aria-label="首页轮播">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in banner" :key="index">
          <SeoLink
            class="banner-link"
            :href="item.url || ''"
            :to="item.url ? null : detailRoute(item)"
            :guard="guardInAppNavigation"
          >
            <img
              @dragstart.prevent
              :src="item.index_banner"
              alt=""
            />
          </SeoLink>
        </van-swipe-item>
      </van-swipe>
      <WxLink v-if="isWeixin && isMobile" :path="wxPath" />
    </section>
    <nav class="categroy position-r" aria-label="首页分类导航">
      <SeoLink
        class="cat-item"
        v-for="(item, index) in category"
        :key="index"
        :to="categoryRoute(item.id)"
        :guard="guardInAppNavigation"
      >
        <img
          class="cat-icon"
          :src="item.icon"
          alt=""
        />
        <div class="cat-title">
          {{ item.name }}
        </div>
      </SeoLink>
      <WxLink v-if="isWeixin && isMobile" :path="wxPath" />
    </nav>
    <section class="card-swiper-box" aria-labelledby="home-daily-title">
      <header class="list-title">
        <h2 id="home-daily-title" class="list-title-left">每日一练</h2>
        <SeoLink class="btn-create" :to="{ name: 'intro' }">
          创建答题<img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220307/768c653e419afe9103dcfab3b14a750a.svg"
            alt=""
          />
        </SeoLink>
      </header>
      <div class="scroll-box">
        <div class="loop-box">
          <SeoLink
            :class="index == 0 ? 'loop-item first' : 'loop-item'"
            v-for="(item, index) in loop"
            :key="index"
            :href="item.url || ''"
            :to="item.url ? null : detailRoute(item)"
            :guard="guardInAppNavigation"
          >
            <div class="loop-header ">
              <div class="position-r">
                <img :src="item.banner" />
                <WxLink v-if="isWeixin && isMobile" :path="wxPath" />
              </div>
              <span class="join-count">{{ item.join_count }}人参与</span>
              <div class="title">{{ item.title }}</div>
            </div>
          </SeoLink>
        </div>
        
      </div>
    </section>
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text=""
      @load="onLoad"
    >
      <section class="list-box" aria-labelledby="home-featured-title">
        <header class="list-title">
          <h2 id="home-featured-title">精选测试</h2>
          <SeoLink class="btn-create" :to="{ name: 'intro' }">
            创建答题 <img :src="right_arrow" />
          </SeoLink>
        </header>
        <SeoLink
          class="list-bd position-r"
          v-for="(item, index) in lists"
          :key="index"
          :href="item.url || ''"
          :to="item.url ? null : detailRoute(item)"
          :guard="guardInAppNavigation"
        >
          <div class="list-right">
            <div class="list-text">
              {{ item.title }}
            </div>
            <div class="list-count">
              <label>{{ item.joined }}</label
              >人已答题
            </div>
          </div>
          <div class="list-icon-bd">
            <img
              class="list-icon"
              :src="item.banner"
            />
            <img
              class="practice-icon"
              :src="practice_icon"
              v-if="item.temp == 1"
            />
            <img
              class="practice-icon"
              :src="practice_daily_icon"
              v-if="item.temp == 2"
            />
            <img
              class="practice-icon"
              :src="question_icon"
              v-if="item.temp == 3"
            />
            <img
              class="practice-icon"
              :src="award_icon"
              v-if="item.temp == 4"
            />
          </div>
          <WxLink v-if="isWeixin && isMobile" :path="wxPath" />
        </SeoLink>
      </section>
    </van-list>
    <footer>
      <FooterTab :activeIndex="0" />
    </footer>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <div class="upgrage-wrapper">
        <div class="upgrage-title">
          H5版本暂不支持<br />
          请使用手机扫码，到小程序操作
        </div>
        <div class="other-way">
          <p><span></span><span></span><span></span></p>
          <div>其他参与方式</div>
          <p><span></span><span></span><span></span></p>
        </div>
        <img
          class="quesQrcode"
          style="margin-top: 20px;"
          src="http://xiaoxiaodati.com/static/media/xcx_qrcode.4bd584e0.jpeg"
          alt=""
        />
        <div class="upgrag-tip">微信长按或扫码参与答题</div>
      </div>
    </van-popup>
  </main>
</template>

<script>
import SeoLink from "@/components/SeoLink.vue";
import questionOnly from "@/utils/questionOnly";
import { reLogin, deepClone, getToken } from "@/utils/common";
import {
  practice_icon,
  practice_daily_icon,
  question_icon,
  award_icon,
  right_arrow
} from "@/utils/config";
import { buildHomeSeo, setSeo } from "@/utils/seo";
import { Toast } from "vant";
import FooterTab from "@/components/footerTab";
import WxLink from "@/components/wxLink.vue";
import { isMobile, isWeixin } from "../../utils/common";
export default {
  components: { FooterTab, SeoLink, WxLink },
  data() {
    return {
      wxPath: "/pages/index/index",
      banner: [],
      category: [],
      loop: [],
      practice_icon,
      practice_daily_icon,
      question_icon,
      award_icon,
      right_arrow,
      lists: [],
      count: 10,
      page: 1,
      loading: false,
      finished: true,
      token: "",
      tabbarHeight: "",
      showVersionTip: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      isInApp: wemeet.app.isTMWebview()
    };
  },
  methods: {
    openWx() {
      this.showVersionTip = true;
    },
    changeToken() {
      localStorage.setItem("token", 1212);
      this.token = 1212;
    },
    clearStorage() {
      localStorage.clear();
      this.token = "";
      Toast("已清除");
    },
    categoryRoute(id) {
      return {
        name: "category",
        query: {
          id: id
        }
      };
    },
    detailRoute(item) {
      return {
        name: "normalDetail",
        query: { qid: item.qid }
      };
    },
    guardInAppNavigation() {
      if (this.isInApp) {
        return true;
      }
      this.openWx();
      return false;
    },
    onLoad() {
      this.getLists(this.page + 1);
    },
    handleCategory(d) {
      this.banner = d.banner;
      this.category = d.category;
      this.loop = d.loop;
      setSeo(buildHomeSeo(d));
    },
    getCategory() {
      questionOnly.get("/xcx/ques/v1/index", {}).then(res => {
        if (res.sta == 0) {
          localStorage.setItem(
            "index_category",
            JSON.stringify({
              index_category_time: new Date().getTime() / 1000,
              index_category_data: res.data
            })
          );
          this.handleCategory(res.data);
        } else if (res.sta == -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    getLists(page = 1) {
      this.page = page;
      let param = {
        type: 3,
        // access_token: getToken(),
        count: this.count,
        page: this.page
      };
      questionOnly.get("/xcx/ques/v1/list", param).then(res => {
        this.loading = false;
        if (res.sta == 0) {
          if (!res.data.length) {
            this.finished = true;
          } else {
            this.finished = false;
            let curList = deepClone(this.lists);
            this.lists = curList.concat(res.data);
          }
        } else if (res.sta == -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  },
  mounted() {
    setSeo(buildHomeSeo());
    if (localStorage.getItem("index_category")) {
      let curTime = new Date().getTime() / 1000;
      let { index_category_time, index_category_data } = JSON.parse(
        localStorage.getItem("index_category")
      );
      if (curTime - index_category_time > 3600 || !index_category_data) {
        this.getCategory();
      } else {
        this.handleCategory(index_category_data);
      }
    } else {
      this.getCategory();
    }
    this.getLists(1);
    this.token = localStorage.getItem("token") || getToken();
    this.tabbarHeight = document.querySelector(".tabbar").clientHeight + "px";
  },
  watch: {
    $route(to) {
      // 监听路由变化, 实现类似 小程序的 onShow 事件
      if (to.path === "/mindex") {
        if (localStorage.getItem("qid")) localStorage.removeItem("qid");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
main,
section,
header,
footer,
nav {
  display: block;
}
h2 {
  margin: 0;
  font: inherit;
  color: inherit;
}
.home {
  background: #fff;
  height: auto;
  min-height: 100vh;
  padding-bottom: 44px;
  max-width: 500px;
  min-width: 320px;
  margin: 0 auto;
  position: relative;
  transition: none;
}
.banner {
  padding: rem(30) rem(30) 0;
  background: #fff;
  box-sizing: border-box;
  .banner-link {
    display: block;
  }
  img {
    width: 100%;
    height: rem(300);
    object-fit: cover;
    border-radius: rem(15);
  }
}
.categroy {
  overflow: hidden;
  margin-left: rem(20);
  padding: rem(40) 0 rem(20);
  display: flex;
  justify-content: space-between;
}
.cat-item {
  // float: left;
  width: rem(142);
  overflow: hidden;
  cursor: pointer;
  display: block;
}
.cat-icon {
  display: block;
  width: rem(88);
  height: rem(88);
  margin: 0 auto;
}
.cat-title {
  text-align: center;
  overflow: hidden;
  font-size: rem(24);
  padding-top: rem(15);
}
.scroll-box {
  margin-top: rem(20);
  height: rem(270);
  overflow: hidden;
}
.loop-box {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}
.loop-item {
  margin-right: rem(20);
  display: inline-block;
  cursor: pointer;
  height: rem(245);
  padding-bottom: rem(5);
}
.loop-item.first {
  margin-left: rem(30);
}
.loop-header {
  position: relative;
  width: rem(310);
  height: rem(245);
  box-shadow: rem(1) rem(1) rem(12) rgba(0, 0, 0, 0.06),
    rem(-1) rem(-1) rem(12) rgba(0, 0, 0, 0.06);
  border-radius: rem(10);
  display: inline-block;
}
.loop-header .title {
  font-size: rem(30);
  height: rem(70);
  box-sizing: border-box;
  line-height: rem(70);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 rem(20);
}
.loop-header img {
  display: block;
  width: rem(310);
  height: rem(175);
  border-radius: rem(10) rem(10) 0 0;
  object-fit: cover;
}
.join-count {
  position: absolute;
  left: rem(15);
  top: rem(130);
  z-index: 10;
  font-size: rem(24);
  color: #fff;
  text-shadow: rem(1) rem(1) rem(6) rgba(0, 0, 0, 0.15),
    rem(-1) rem(-1) rem(6) rgba(0, 0, 0, 0.15);
}
.card-swiper-box .list-title {
  padding: rem(35) rem(30) rem(10);
  display: flex;
  justify-content: space-between;
}
.list-title-left {
  font-size: rem(32);
  font-weight: bold;
}
.btn-create {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: rem(28);
  font-weight: 400;
  color: #1890ff;
  background-color: #f0f7fa;
  width: rem(195);
  height: rem(60);
  line-height: rem(60);
  border-radius: rem(31);
  cursor: pointer;
}
.btn-create img {
  display: block;
  width: rem(20);
  height: rem(20);
  margin-left: rem(8);
}
.list-box {
  margin: 0 rem(30);
}
.list-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: rem(34);
  font-weight: 900;
  padding: rem(25) 0 rem(40);
  color: #333;
}
.btn-create {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: rem(28);
  font-weight: 400;
  color: #1890ff;
  background-color: #f0f7fa;
  width: rem(195);
  height: rem(60);
  line-height: rem(60);
  border-radius: rem(31);
}
.btn-create img {
  display: block;
  width: rem(20);
  height: rem(20);
  margin-left: rem(8);
}
.list-bd {
  position: relative;
  display: flex;
  margin-bottom: rem(40);
  cursor: pointer;
}
.list-bd .list-icon {
  display: block;
  width: rem(240);
  height: rem(136);
  object-fit: cover;
  border-radius: rem(10);
}
.list-icon-bd {
  position: relative;
}
.list-right {
  flex: 1;
  margin-right: rem(20);
  display: flex;
  flex-direction: column;
  height: rem(140);
  justify-content: space-between;
}
.list-text {
  font-size: rem(32);
  color: #000;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  width: rem(420);
}
.list-count {
  font-size: rem(24);
  color: #999;
}

.practice-icon {
  position: absolute;
  left: 0;
  top: rem(10);
  width: rem(103);
  height: rem(41);
}
.upgrage-wrapper {
  padding: 25px;
  font-size: 17px;
  text-align: center;
  color: #262626;
  .upgrage-title {
    line-height: 25px;
    margin-top: 15px;
  }
  .contact-btn {
    height: 43px;
    line-height: 43px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 2px;
    font-size: 16px;
    margin: 20px auto;
  }
  .other-way {
    display: flex;
    color: #999999;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    margin-top: 20px;
    div {
      margin: 0 4px;
    }
    p {
      // height: 1px;
      flex: 1;
      border-bottom: 1px dashed #999;
    }
  }
  .quesTitle {
    line-height: 21px;
    font-weight: 700;
    margin: 20px 0 15px;
  }
  .quesQrcode {
    width: 160px;
    height: 160px;
    object-fit: cover;
    margin: 0 auto 15px;
    display: block;
  }
  .upgrag-tip {
    display: inline-block;
    font-size: 14px;
    line-height: 21px;
    border: 1px dashed #ccc;
    padding: 6px 10px;
    color: #999;
  }
}
#launch-btn {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue